import { useEffect, useMemo } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useQrStore } from '../../../../../../store/use-qr-store';
import { defaultDashboardRange } from '../../../../navigation/navigation-tabs';

export const useDashboardFilters = () => {
  const { getLocale, t } = useLang();

  const { fetchBranches, place, isLoadingFetch: isLoadingBranches } = useBranchesStore();
  const { fetchAllQrs, allQrs, isLoadingFetch: isLoadingQrs } = useQrStore();

  const { addQueryParams, getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const range = params.range;
  const branch = params.branch;

  const branches = useMemo(() => {
    return place?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];
  }, [getLocale, place]);

  const qrs = useMemo(() => {
    return allQrs?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];
  }, [getLocale, allQrs]);

  useEffect(() => {
    const to = range ? JSON.parse(range)?.to : undefined;
    if (!to) {
      addQueryParams({ range: JSON.stringify(defaultDashboardRange) });
    }
  }, [range, addQueryParams]);

  useEffect(() => {
    fetchBranches({ n: 1000, since_id: 0, customCache: true });
    fetchAllQrs();
  }, []);

  useEffect(() => {
    if (place && !branch) {
      addQueryParams({ branch: JSON.stringify(place[0].id) });
    }
  }, [place, addQueryParams]);

  return {
    branches,
    isLoadingFetch: isLoadingBranches || isLoadingQrs,
    qrs,
    t,
  };
};
